import { PostsModerationView } from "./PostsModerationView";

export function PostsPage() {
  return <PostsModerationView title="Posts & Moments" emptyTitle="No posts yet" />;
}
